import { groupedCount } from "@wetalk/view-model/format";
import { talkTimePartsOf, talkTimeSecondText } from "@wetalk/view-model/talk-time";

import { portalText, portalLocale } from "./i18n/portal.js";
/**
 * Talk time on screen — one shape, everywhere the portal states an amount of it.
 *
 * Owner decision (2026-10-09): talk time is always minutes AND seconds — "0 min 52 s",
 * "12 min 05 s", "1,020 min 34 s". The dashboard used to floor 52 seconds to "0" while the
 * agent row rounded the same 52 seconds to "1 min today"; carrying whole seconds through every
 * view model and formatting them here, once, means two places can no longer disagree.
 *
 * The seconds are always two digits (`00`–`59`), so a column of figures lines up and a zero
 * day reads "0 min 00 s" rather than a bare "0 min". A fraction of a second is dropped, never
 * rounded up: the portal never shows a second that was not talked.
 *
 * Plan and price figures that are whole minutes by definition — "100 included minutes",
 * a talk rate a minute, an approximate campaign estimate — are catalogue quantities, not talk time,
 * and do not come through here (a rate is worded by `talkRateText`, `./api/slice/talk-rate.ts`).
 */

/**
 * The parts are `@wetalk/view-model/talk-time`'s (plan-034 VIEW-PKG), shared with the wetalk app; the words are the
 * portal's own.
 *
 * `52` → "0 min 52 s"; `725` → "12 min 05 s"; `61234` → "1,020 min 34 s".
 */
export function talkTimeText(second: number): string {
  const parts = talkTimePartsOf(second);
  return portalText("shell", "value_min_value_s_7a6246d3", { v0: groupedCount(portalLocale(), parts.minute), v1: talkTimeSecondText(parts.second) });
}
